<template lang="pug">
	.ssml--play-ht-settings.flex-col.space
		.flex-col.space.margin-bottom
			.flex-row.justify
				.grey.upper.small-font {{$tCaption('Seed')}}
				.helper
					fas(icon="circle-question", id="seedHelp")
					DxTooltip(target="#seedHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--play-ht-settings.tooltip-content {{seedDesc}}
			DxNumberBox(:value.sync="settings.Seed", :min="0", :max="99999", :show-spin-buttons="true", :step="1", :showClearButton="true", stylingMode="filled")
		.flex-col.space.margin-bottom
			.flex-row.justify
				.grey.upper.small-font {{$tCaption('Temperature')}}
				.helper
					fas(icon="circle-question", id="temperatureHelp")
					DxTooltip(target="#temperatureHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--play-ht-settings.tooltip-content {{temperatureDesc}}
			DxNumberBox(:value.sync="settings.Temperature", :min="0", :max="2", :show-spin-buttons="true", :step="0.01", :showClearButton="true" stylingMode="filled")
		.flex-col
			.flex-row.justify
				.grey.upper.small-font {{$tCaption('Voice guidance')}}  {{$Data.formatNumber(settings.VoiceGuidance, '#0.0#')}}
				.helper
					fas(icon="circle-question", id="guidanceHelp")
					DxTooltip(target="#guidanceHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--play-ht-settings.tooltip-content {{voiceGuidanceDesc}}
			DxSlider(:value.sync="settings.VoiceGuidance", :min="1", :max="6", :show-spin-buttons="true", :step="0.1", :show-range="false")
		.flex-col
			.flex-row.justify
				.grey.upper.small-font {{$tCaption('Style')}}  {{$Data.formatNumber(settings.Style, '#0.0')}}
				.helper
					fas(icon="circle-question", id="guidanceHelp")
					DxTooltip(target="#guidanceHelp", show-event="dxhoverstart", hide-event="dxhoverend", width="400")
						pre.pre-wrap.ssml--play-ht-settings.tooltip-content {{styleDesc}}
			DxSlider(:value.sync="settings.Style", :min="1", :max="30", :show-spin-buttons="true", :step="0.1", :show-range="false")
			
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxSlider from 'devextreme-vue/slider';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import { DxTooltip } from 'devextreme-vue/tooltip';

	export default {
		translationCategory: 'insertion.SSMLPlayHtSettings',
		name: 'ssml--play-ht-settings',
		components: { DxButton,  DxSlider, DxCheckBox, DxTooltip, DxNumberBox },
		props: ['record'],
		data() {
			
			return {
				seedDesc: this.$tCaption(`An integer number greater than or equal to 0. If not specified, a random seed will be used. Useful to control the reproducibility of the generated audio. Assuming all other properties didn't change, a fixed seed should always generate the exact same audio file.`),
				temperatureDesc: this.$tCaption(`A floating point number between 0, inclusive, and 2, inclusive. If not specified, the model's default temperature will be used. The temperature parameter controls variance. Lower temperatures result in more predictable results, higher temperatures allow each run to vary more, so the voice may sound less like the baseline voice.`),
				voiceGuidanceDesc: this.$tCaption(`A number between 1 and 6. Use lower numbers to reduce how unique your chosen voice will be compared to other voices. Higher numbers will maximize its individuality.`),
				styleDesc: this.$tCaption('A number between 1 and 30. Use lower numbers to to reduce how strong your chosen emotion will be. Higher numbers will create a very emotional performance.')
			};
		},
		computed: {
			settings() {
				return this.record.voiceSettings || {};
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.playHtSettings = this;

			this.init();
		},
		methods: {
			init() {
				if (!this.record.voiceSettings || this.record.voiceSettings?.TtsProviderType !== 5) {
					this.$set(this.record, 'voiceSettings', {
						...(this.record.voiceSettings || {}),
						Seed: null,
						Temperature: null,
						VoiceGuidance: 3,
						Style: 10
					});
				}
			}
		}
	};
</script>
<style lang='scss'>
	.ssml--play-ht-settings {
		&.tooltip-content {
			text-align: left;
		}

		.helper {
			color: #c1c1c1;
		}
	}
</style>
